var React = require('react');

function ReportLarge (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18 2H8v4.022A5.5 5.5 0 0 1 11.663 16H18V2Z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.103 15.31a4.5 4.5 0 1 0-1.413-1.413L2 16.586 3.413 18l2.69-2.69ZM11 11.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z","fill":"currentColor","key":1})]);
}

ReportLarge.defaultProps = {"width":"20","height":"20","fill":"none","viewBox":"0 0 20 20"};

module.exports = ReportLarge;

ReportLarge.default = ReportLarge;
